import SessionGrid from "../../components/DataGrid/SessionGrid";

export default function Session() {
  return (
    <main>
      <SessionGrid />
    </main>
  );
}
